<!--Tạo lô hợp đồng-->
<mat-card>
  <form>
    <mat-card-header>
      <mat-card-title class="mat-card-title-custom">
        <span *ngIf="viewMode === 'create'">{{ "title.create_lot_digital" | translate }}</span>
        <span *ngIf="viewMode === 'view'">{{ "title.view_lot" | translate }}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
      
      <!-- Stepper mimicking the mockup -->
      <div class="steps-title mt-3" *ngIf="viewMode === 'create'" style="background-color: #fff; padding: 24px 15% !important; border-radius: 12px; border: 1px solid #e0e0e0;">
        <nz-steps [nzCurrent]="1" class="mb-3">
          <nz-step [nzTitle]="titleStep1">
            <ng-template #titleStep1>{{ 'digital_lot.step_upload_pdf' | translate }}</ng-template>
          </nz-step>
          <nz-step [nzTitle]="titleStep2">
            <ng-template #titleStep2>{{ 'digital_lot.step_upload_excel' | translate }}</ng-template>
          </nz-step>
        </nz-steps>
      </div>

      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel [expanded]="true" class="mb-3 mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title" style="font-weight: 500; font-size: 16px; color: #000000DE;">
              {{ 'digital_lot.general_info' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="px-4 py-2" style="padding: 0px !important;">
            <div class="row mb-3 align-items-center">
              <div class="col-2" style="font-weight: 500; font-size: 14px; color: #000000DE;">{{ 'digital_lot.contract_type' | translate }}:</div>
              <div class="col-10" style="font-size: 14px; color: #000000DE;">{{ contractType ? contractType.name : '' }}</div>
            </div>
            <div class="row mb-3 align-items-center" *ngIf="contractType && contractType.employmentContractTerm">
              <div class="col-2" style="padding-right: 5px ;font-weight: 500; font-size: 14px; color: #000000DE;">{{ 'digital_lot.labor_contract_type' | translate }}:</div>
              <div class="col-10" style="font-size: 14px; color: #000000DE;">
                {{ (contractType.employmentContractTerm === 'LIMITED' ? 'digital_lot.term_limited'
                    : (contractType.employmentContractTerm === 'UNLIMITED' ? 'digital_lot.term_unlimited' : '')) | translate }}
              </div>
            </div>
            <div class="row mb-3 align-items-center">
              <div class="col-2" style="font-weight: 500; font-size: 14px; color: #000000DE;">{{ 'digital_lot.download_template_label' | translate }}:</div>
              <div class="col-10">
                <button mat-stroked-button (click)="downloadFileTemplate()" type="button" style="border-radius: 4px; padding: 0 16px; height: 32px; line-height: 30px; border-color: #d9d9d9;">
                  <span><svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.08333 0.974609V4.41673C9.08333 4.88344 9.08333 5.11679 9.17416 5.29505C9.25406 5.45185 9.38154 5.57934 9.53834 5.65923C9.7166 5.75006 9.94996 5.75006 10.4167 5.75006H13.8588M7.41667 14.0833V9.08333M4.91667 11.5833H9.91667M9.08333 0.75H4.75C3.34987 0.75 2.6498 0.75 2.11502 1.02248C1.64462 1.26217 1.26217 1.64462 1.02248 2.11502C0.75 2.6498 0.75 3.34987 0.75 4.75V13.4167C0.75 14.8168 0.75 15.5169 1.02248 16.0516C1.26217 16.522 1.64462 16.9045 2.11502 17.1442C2.6498 17.4167 3.34987 17.4167 4.75 17.4167H10.0833C11.4835 17.4167 12.1835 17.4167 12.7183 17.1442C13.1887 16.9045 13.5712 16.522 13.8108 16.0516C14.0833 15.5169 14.0833 14.8168 14.0833 13.4167V5.75L9.08333 0.75Z" stroke="#EE0033" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    </span>
                  <span style="padding-left: 10px ;font-size: 13px; color: #000000DE;">{{ 'digital_lot.download_template' | translate }}</span>
                </button>
              </div>
            </div>
            <div class="row mb-3 align-items-center" *ngIf="viewMode !== 'view'">
              <!-- Tiêu đề -->
              <div [ngClass]="fileName ? 'col-12 col-md-2' : 'col-12 mb-2'"
                   style="font-weight: 500; font-size: 14px; color: #000000DE;">
                {{ 'digital_lot.upload_data' | translate }} <span style="color: #e3001b;">*</span>
              </div>
            
              <!-- Nội dung upload -->
              <div [ngClass]="fileName ? 'col-12 col-md-10' : 'col-12'">
                <input type="file" id="file" name="file" style="display: none"
                       (change)="onChangeFile($event)" accept=".xlsx, .xls"
                       onclick="this.value = null" />
            
                <!-- Chưa có file -->
                <div *ngIf="!fileName" #uploadBox class="upload-box"
                    [class.drag-over]="isDragOver"
                    (click)="uploadFile()"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)">
                  <mat-icon class="upload-icon">cloud_upload</mat-icon>
                  <div style="font-size: 14px; color: #000000DE;">
                    <span style="color: #ee0033; font-weight: 500;">{{ 'digital_lot.upload' | translate }}</span> {{ 'digital_lot.or_drag_document' | translate }}
                  </div>
                  <div class="mt-1" style="color: #8c8c8c; font-size: 12px;">
                    {{ 'digital_lot.excel_upload_hint' | translate }}
                  </div>
                </div>
            
                <!-- Đã có file: cùng hàng với tiêu đề -->
                <div *ngIf="fileName" class="d-flex align-items-center justify-content-between">
                  <span class="file-name"
                        [class.error-file]="errorFile"
                        style="font-size: 14px; font-weight: 500; color: #3f1dcb;">
                    {{ fileName }}
                  </span>
            
                  <button mat-stroked-button (click)="uploadFile()"
                          style="color: #ee0033 ;font-size: 13px; font-weight: 500;">
                    <mat-icon>cloud_upload</mat-icon>
                    {{ 'digital_lot.choose_other_file' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Hiển thị tên file đã import ở chế độ view -->
            <div class="row mb-3 align-items-center" *ngIf="viewMode === 'view'">
              <div class="col-2" style="font-weight: 500; font-size: 14px; color: #000000DE;">{{ 'digital_lot.upload_data' | translate }}:</div>
              <div class="col-10">
                <span style="font-size: 14px; color: #1890ff;">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle; margin-right: 4px; margin-top: -2px; color: #e3001b;">insert_drive_file</mat-icon>
                  {{ fileName || '-' }}
                </span>
              </div>
            </div>
          </div>

        </mat-expansion-panel>

        <!-- Danh sách file PDF đã tải lên - chỉ hiển thị ở chế độ view -->
        <mat-expansion-panel [expanded]="true" class="mb-3" *ngIf="viewMode === 'view'">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title" style="font-weight: 500; font-size: 16px; color: #000000DE;">
              {{ 'digital_lot.pdf_list_uploaded' | translate }} ({{ pdfFileList.length }})
            </mat-panel-title>
            <mat-panel-description style="justify-content: flex-end; font-size: 14px; color: #000000DE; margin-right: 0; width: 130px; padding-right: 20px; align-items: center;">
              {{ 'digital_lot.total_files' | translate }}: {{ pdfFileList.length }}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <nz-table #pdfTable nzBordered [nzData]="pdfFileList" [nzShowPagination]="false"
                    [nzFrontPagination]="false" [nzNoResult]="contentEmptyPdfTable"
                    class="ant-table-no-placeholder-border-bottom">
            <thead>
              <tr>
                <th class="text-center" nzWidth="60px">{{ 'digital_lot.stt' | translate }}</th>
                <th class="text-center">{{ 'digital_lot.pdf_file_name' | translate }}</th>
                <th class="text-center" nzWidth="200px">{{ 'digital_lot.upload_result' | translate }}</th>
                <!-- <th class="text-center">{{ 'digital_lot.error_message' | translate }}</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of pdfTable.data; let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td matTooltip="{{ item.fileName }}">{{ item.fileName }}</td>
                <td class="text-center">
                  <nz-tag *ngIf="item.status === 'SUCCESS' || item.uploadStatus === 'SUCCESS'" [nzColor]="'green'" style="margin-right: 0px;">
                    {{ 'digital_lot.success' | translate }}
                  </nz-tag>
                  <nz-tag *ngIf="item.status === 'ERROR' || item.uploadStatus === 'FAILD' || item.status === 'FAILD'" [nzColor]="'red'" style="margin-right: 0px;">
                    {{ 'digital_lot.failed' | translate }}
                  </nz-tag>
                  <nz-tag *ngIf="item.status !== 'SUCCESS' && item.uploadStatus !== 'SUCCESS' && item.status !== 'ERROR' && item.uploadStatus !== 'FAILD' && item.status !== 'FAILD'" style="margin-right: 0px;">
                    -
                  </nz-tag>
                </td>
                <!-- <td class="text-center" matTooltip="{{ item.errorMessage }}">{{ item.errorMessage || '-' }}</td> -->
              </tr>
            </tbody>
          </nz-table>
          <ng-template #contentEmptyPdfTable></ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" class="mb-3" #expansionData>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "digital_lot.setting_internal" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
              <app-config-signing-flow-moha #configSign (getDefault)="getDefault($event)"
                                       (changeUseDataForTemplate)="useCreateSide($event)"
                                       (setUserSign)="setUserSign($event)"
                                       (DATA_RECORD_USER_PERFORM_SIGN)="setDataRecordUserPerformSign($event)"
                                       [data_foot_note]="dataFootNote"
                                       [record_party_sign]="contractLot && contractLot.enterpriseSign? contractLot.enterpriseSign: []"
                                       [record_user_perform_sign]="contractLot && contractLot.userSign? contractLot.userSign: dataUserSign"
                                       [disabled]="viewMode === 'view'"
                                       [selectedServiceType]="serviceType"
                                       [viewMode]="viewMode"
                                       (maxNumberOfCustomerInFlowOutput)="setMaxNumberOfPartner($event)"
              ></app-config-signing-flow-moha>
        </mat-expansion-panel>

        <mat-expansion-panel expanded="true" class="mb-3" *ngIf="viewMode === 'view'" disabled>
          <mat-tab-group class="list-contract">
            <mat-tab label="{{ 'title.list_contract_create' | translate }}">
              <div class="row my-3" style="width: 100%">
                <div class="col-3 title-panel">
                  
                </div>
                <div class="col-9 d-flex justify-content-between" *ngIf="processing">
                  <div class=" title-panel" style="font-size: 15px !important; font-weight: 600 !important;">{{ "contract_lot.contract_lot_moha_processing" | translate }} ({{
                    processing.percent ? processing.percent : 0 }}%)</div>
                  <div class="d-flex flex-column justify-content-center" style="width: calc(100% - 200px);">
                    <mat-progress-bar mode="determinate" [value]="processing.percent" [bufferValue]="100">
                    </mat-progress-bar>
                  </div>
                </div>
              </div>
              <div class="contract-lot-detail">
                <div class="row">
                  <div class="col-12 d-flex justify-content-between">
                    <div>
                      <b>{{ "contract_lot.contract_lot_code" | translate }}:</b>
                      {{
                      contractLot && contractLot.code ? contractLot.code : null
                      }}
                    </div>
                    <div class="d-flex">
                      <div class="mr-4">
                        <b>{{ "contract_lot.total_contract" | translate }}:</b>
                        {{ renderNumber("total") }}
                      </div>
                      <div class="mr-4">
                        <b>{{ "contract_lot.contract_success" | translate }}:</b>
                        {{ renderNumber("success") }}
                      </div>
                      <div>
                        <b>{{ "contract_lot.contract_error" | translate }}:</b>
                        {{ renderNumber("error") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 d-flex justify-content-between pt-4 pb-2 align-items-center">
                    <div class="d-flex align-items-center cursor-pointer" (click)="isExpandResult = !isExpandResult" style="cursor: pointer; user-select: none;">
                      <span class="font-weight-bold" style="font-size: 15px;">{{ 'digital_lot.result_detail' | translate }}</span>
                    </div>
                    <a class="file-result" *ngIf="!processing" (click)="getResultFile()" style="cursor: pointer;">
                      {{ "contract_lot.download_result_file" | translate }}
                    </a>
                  </div>
                  <div class="col-12" *ngIf="isExpandResult">
                    <nz-table #rowsTable nzBordered [nzData]="(contractDetailsList && contractDetailsList.length > 0) ? contractDetailsList : (contractLot && contractLot.contractDetails ? contractLot.contractDetails : [])" [nzShowPagination]="false"
                      [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                      <thead>
                        <tr>
                          <th class="text-center" nzWidth="60px">
                            {{ 'digital_lot.stt' | translate }}
                          </th>
                          <th class="text-center" nzWidth="120px">
                            {{ 'import_file.table_detail.line_in_excel' | translate }}
                          </th>
                          <th class="text-center" nzWidth="22%">
                            {{ 'digital_lot.contract_document' | translate }}
                          </th>                          
                          <th class="text-center" nzWidth="16%">
                            {{ 'digital_lot.contract_code_short' | translate }}
                          </th>
                          <th class="text-center" nzWidth="18%">
                            {{ 'digital_lot.worker_name' | translate }}
                          </th>
                          <th class="text-center" nzWidth="14%">
                            {{ 'digital_lot.certificate_no' | translate }}
                          </th>
                          <th class="text-center" nzWidth="120px">
                            {{ 'digital_lot.status' | translate }}
                          </th>
                          <th class="text-center">
                            {{ 'digital_lot.detail' | translate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let data of rowsTable.data; let i = index">
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="text-center" nz-tooltip [nzTooltipTitle]="data.orderNo">
                            {{ data.orderNo || '-' }}
                          </td>
                          <td nz-tooltip [nzTooltipTitle]="data.contractName || data.name">
                            {{ (data.contractName || data.name) ? ((data.contractName || data.name) | slice:0:30) : '-' }}
                            <span *ngIf="(data.contractName || data.name) && (data.contractName || data.name).length > 30">...</span>
                          </td>
                          <td nz-tooltip [nzTooltipTitle]="data.contractCode || data.code">
                            {{ (data.contractCode || data.code) ? ((data.contractCode || data.code) | slice:0:20) : '-' }}
                            <span *ngIf="(data.contractCode || data.code) && (data.contractCode || data.code).length > 20">...</span>
                          </td>                         
                          <td nz-tooltip [nzTooltipTitle]="data.customerName">
                            {{ data.customerName ? (data.customerName | slice:0:30) : '-' }}
                            <span *ngIf="data.customerName && data.customerName.length > 30">...</span>
                          </td>
                          <td class="text-center" nz-tooltip [nzTooltipTitle]="data.certificateNo">
                            {{ data.certificateNo ? data.certificateNo : '-' }}
                          </td>
                          <td class="text-center">
                            <nz-tag *ngIf="data.status === 'DONE' || data.status === 'SUCCESS'" [nzColor]="'green'" style="margin-right: 0px;">
                              {{ 'digital_lot.success' | translate }}
                            </nz-tag>
                            <nz-tag *ngIf="data.status === 'PROCESSING'" [nzColor]="'blue'" style="margin-right: 0px;">
                              {{ 'digital_lot.processing' | translate }}
                            </nz-tag>
                            <nz-tag *ngIf="data.status === 'ERROR' || data.status === 'FAILD'" [nzColor]="'red'" style="margin-right: 0px;">
                              {{ 'digital_lot.failed' | translate }}
                            </nz-tag>
                            <span *ngIf="!data.status || (data.status !== 'DONE' && data.status !== 'SUCCESS' && data.status !== 'PROCESSING' && data.status !== 'ERROR' && data.status !== 'FAILD')">-</span>
                          </td>
                          <td class="text-center" nz-tooltip [nzTooltipTitle]="data.errorMessage">
                            {{ data.errorMessage ? (data.errorMessage | slice:0:40) : '-' }}
                            <span *ngIf="data.errorMessage && data.errorMessage.length > 40">...</span>
                          </td>
                        </tr>
                      </tbody>
                    </nz-table>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab  label="{{ 'title.info_cotract_report_list' | translate }}">
              <div class="contract-lot-detail">
                <p style="font-weight: 700; font-size: 16px; margin-top: 24px;">{{'contract_lot.result' | translate}}</p>
                <nz-table class="mt-2" *ngIf="tableData && dynamicColumns && tableData.length > 0 && dynamicColumns.length > 0; else noRecord" 
                  #basicTable [nzShowPagination]="false" [nzData]="tableData" 
                  [nzBordered]="true" [nzScroll]="{ x: 'max-content' }">
                  <thead>
                    <tr class="lot-group-header-row">
                      <!-- Ô nhóm trống cho các cột cố định -->
                      <th colspan="4"></th>
                      <!-- Header nhóm cho cột động -->
                      <th class="lot-group-cell text-center" *ngFor="let groupName of lotGroupRowColumns; let i = index"
                        [attr.colspan]="lotGroupColumns[i].span">
                        {{ lotGroupColumns[i].name }}
                      </th>
                    </tr>
                    <tr>
                      <!-- Cột cố định -->
                      <th class="text-center">{{ 'digital_lot.stt' | translate }}</th>
                      <th class="text-center">
                        {{ 'add_document_moha.contract_code' | translate }}
                      </th>
                      <th class="text-center">
                        {{ 'add_document_moha.contract_name' | translate }}
                      </th>
                      <th class="text-center">
                        {{ 'add_document_moha.labor_contract_type' | translate }}
                      </th>
                      <!-- <th class="text-center">
                        {{ 'add_document_digital.UUID' | translate }}
                      </th> -->
                      <!-- Cột động -->
                      <th style="max-width: 250px;" class="text-center" *ngFor="let col of dynamicColumns">
                        {{ col.name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of tableData; let i = index;">
                      <!-- Data cố định -->
                      <td class="text-center">{{i + 1}}</td>
                      <td style="max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                        [matTooltip]="row.contractCode">
                           {{ row.contractCode }}
                      </td>
                      <td style="max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                         [matTooltip]="row.contractName">
                          {{ row.contractName }}
                      </td>
                      <td style="max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                        [matTooltip]="row.serviceTypeName">
                           {{ row.serviceTypeName }}
                      </td>
                      <!-- <td style="max-width: 250px;">
                        {{ row.contractDigitalUuid }}
                      </td> -->
                      <!-- Data động -->
                      <td *ngFor="let col of row.reportFields"
                          [matTooltip]="col.inputType !== 'DATETIME'
                            ? col.value
                            : (col.value | date: 'dd/MM/yyyy')">
                        <div class="cell-ellipsis" *ngIf="col.inputType !== 'DATETIME'">
                         {{ col.value }}
                        </div>
                        <div class="cell-ellipsis text-center" *ngIf="col.inputType === 'DATETIME'">
                          {{ col.value | date: 'dd/MM/yyyy' }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
                <ng-template #noRecord>
                  <div class="text-center mb-2">{{ 'user_group.no_result' | translate}}</div>
                </ng-template>
              </div>
            </mat-tab>
          </mat-tab-group>
          
        </mat-expansion-panel>

        <div class="pr-0 fixed-bottom">
          <div class="bg-white text-center mat-elevation-z0 py-2 w-100" style="height: 60px">
            <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button"
              *ngIf="viewMode === 'create'" (click)="onClickCancel()">
              <mat-icon class="mr-0">cancel</mat-icon>
              {{ "button.cancel" | translate }}
            </button>
            <button mat-raised-button color="primary" class="mr-3" type="button" (click)="submit()"
              *ngIf="viewMode === 'create'" [disabled]="!fileName || configSignComponent.checkOrder">
              <mat-icon class="mr-0">save</mat-icon>
              {{ "digital_lot.import_lot" | translate }}
            </button>
          </div>
        </div>
      </mat-accordion>
    </mat-card-content>
  </form>
</mat-card>